import Vue from 'vue';

export const canNavigate = (to: any) =>
  to.matched.some((route: any) => {
    return Vue.prototype.$ability.can(route.meta.action || 'read', route.meta.resource);
  });

export const _ = undefined;
